import { BackendDate } from '../../helper/backend-frontend-conversion.helper';
import { ContractParticipant } from '../../mdqx-graphql-types';
export class ContractParticipantEntity {
    public static readonly GqlFields = 'contractId customerId id entryDate endDate ausnahmedatum';

    public ContractId: number;
    public CustomerId: number;
    public Id: number;
    public EntryDate: Date | null;
    public EndDate: Date | null;
    public Ausnahmedatum: Date | null;

    constructor(contractParticipantType?: ContractParticipant | null) {
        if (contractParticipantType && contractParticipantType.contractId != null && contractParticipantType.customerId != null && contractParticipantType.id != null) {
            this.ContractId = contractParticipantType.contractId;
            this.CustomerId = contractParticipantType.customerId;
            this.Id = contractParticipantType.id;
            this.EntryDate = contractParticipantType.entryDate ? BackendDate(contractParticipantType.entryDate) : null;
            this.EndDate = contractParticipantType.endDate ? BackendDate(contractParticipantType.endDate) : null;
            this.Ausnahmedatum = contractParticipantType.ausnahmedatum ? BackendDate(contractParticipantType.ausnahmedatum) : null;
        } else {
            console.error('received broken ContractParticipantType', contractParticipantType);
            throw Error();
        }
    }
}
